import {
	Box,
	Divider,
	ListItemIcon,
	Menu,
	MenuItem,
	Typography,
} from '@mui/material';
import { LogoutIcon } from '../assets/icons/Icons';
import packageJson from '../../package.json';
import Avatar from '../assets/images/Avatar.png';
import { getUserEmail, getUserName } from '../Utils/AuthUtil';
import { MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface TopBarDropdownMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	handleClose: () => void;
	onLogout: () => void;
}

function TopBarDropdownMenu({
	anchorEl,
	open,
	handleClose,
	onLogout,
}: TopBarDropdownMenuProps) {
	const appVersion = packageJson.version;

	return (
		<Menu
			anchorEl={anchorEl}
			id="account-menu"
			open={open}
			onClose={handleClose}
			onClick={handleClose}
			slotProps={{
				paper: {
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'& .MuiAvatar-root': {
							width: 32,
							height: 32,
							ml: -0.5,
							mr: 1,
						},
						'&::before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				},
			}}
			transformOrigin={{ horizontal: 'right', vertical: 'top' }}
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
			<MenuItem
				disableRipple
				onClick={event => event.stopPropagation()}
				sx={{ justifyContent: 'center' }}>
				<Box display="flex" alignItems="center" gap={1}>
					<Box
						component={'img'}
						src={Avatar}
						width={36}
						height={36}
					/>
					<Box>
						<Typography color={MAIN_THEME_COLOR} fontWeight="bold">
							{getUserName()}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{getUserEmail()}
						</Typography>
					</Box>
				</Box>
			</MenuItem>
			<Divider />
			<MenuItem
				disableRipple
				onClick={event => event.stopPropagation()}
				sx={{ justifyContent: 'center' }}>
				{`SenzToura v${appVersion}`}
			</MenuItem>
			<Divider />
			<MenuItem onClick={onLogout} sx={{ justifyContent: 'center' }}>
				<ListItemIcon>
					<LogoutIcon color={'#7C7C7C'} />
				</ListItemIcon>
				Logout
			</MenuItem>
		</Menu>
	);
}

export default TopBarDropdownMenu;
